import { defineMessages } from 'react-intl';

export default defineMessages({
  releve_situation: {
    id: 'dashboard_epargn.releve_situation',
  },
  contracts: {
    id: 'dashboard_epargn.contrats',
  },
});
